import React from "react"
import CustomTag from "components/Atoms/CustomTag"
import StyledLink from "components/Atoms/StyledLink"
import CustomReactTable from "components/Templates/CustomReactTable"

const OrdersTable = ({ tripId, orders }) => {
  const COLUMNS = [
    {
      Header: "",
      accessor: "bookingsByTrip.0.loadingSequence",
      minWidth: 40,
      Cell({ value }) {
        return (
          <div style={{ width: "30px" }} className="vt-text-center">
            {value}
          </div>
        )
      },
    },
    {
      Header: "Order ID",
      accessor: "trackingCode",
      Cell({ value }) {
        return (
          <>
            <StyledLink to={`/d/ecom/dms/trip/${tripId}?order=${value}`}>
              {`#${value}`}
            </StyledLink>
          </>
        )
      },
    },
    {
      Header: "Customer's Name",
      accessor: "user.fullName",
      Cell({ value }) {
        return (
          <>
            <div className="vt-text-center">{value}</div>
          </>
        )
      },
    },
    {
      Header: "Address",
      accessor: "shippingAddress.address",
      Cell({ value }) {
        return <div>{value}</div>
      },
    },
    {
      Header: "Remark",
      accessor: "bookingsByTrip",
      Cell({ value }) {
        const count = value.filter(
          o => o.driverDespatchRemark && o.driverDespatchRemark !== ""
        ).length
        return <div className="vt-text-center">{count}</div>
      },
    },
  ]

  return (
    <div>
      <div className="mx-2 my-1">
        <CustomTag className="m-2" intent="success">
          {orders?.filter(o => o.orderStatus === "DES").length} orders done
        </CustomTag>
        <CustomTag className="m-2" intent="danger">
          {orders?.filter(o => o.orderStatus !== "DES").length} orders pending
        </CustomTag>
      </div>

      <CustomReactTable
        className="vt-dms-react-table"
        getTrProps={(_, row) => {
          const bookingsByTrip = row?.original?.bookingsByTrip
          const count = bookingsByTrip?.filter(
            o => o.driverDespatchRemark && o.driverDespatchRemark !== ""
          ).length
          if (count) {
            return {
              className: "vt-order-dms-missing",
            }
          } else if (row?.original?.orderStatus === "DES") {
            return {
              className: "vt-order-dms-completed",
            }
          } else {
            return {
              className: "vt-order-dms-remaining",
            }
          }
        }}
        data={orders}
        columns={COLUMNS}
      />
    </div>
  )
}

export default OrdersTable
